import { hasFormSubmit } from '@testing-library/user-event/dist/utils';
import React, { useRef } from 'react'

function ChatForm({setChatHistory}) {
    const inputRef = useRef();

    const handleFormSubmit = (e) =>{
        e.preventDefault();
        const userMessage = inputRef.current.value.trim();
        if(!userMessage) return;
        inputRef.current.value="";
        console.log(userMessage);
        setChatHistory(history => [...history, {role: "user", text:  userMessage}]);
    }
  return (
    
      <form className='chat-form' action="#" onSubmit={handleFormSubmit}>
         <input
         type='text' placeholder='message...'
         className='message-input' required/>
               <button className='material-symbols-rounded'><i class="bi bi-caret-up-fill"></i></button>

         </form>
    
  )
}

export default ChatForm
